export default __webpack_public_path__ + "static/difiLogo-944d9eb144a1c7ee55f724a34cc5918f.png";